import styled from 'styled-components'
import { media } from '../theme'

const Mobile = styled.div`
  display: block;
  height: 100%;

  @media (min-height: 600px) and (min-width: ${p =>
      p.theme.mediaSizes.medium}px) {
    display: none;
  }
`

export default Mobile



// WEBPACK FOOTER //
// ./src/components/Mobile.js